<template>
  <div class="sdk-detection-view">
    <div class="step-wrap">
      <arrow-steps :step="currentStep > 3 ? 3 : currentStep"
                   :stepOpt="stepOpt"></arrow-steps>
    </div>
    <div class="view-content"
         v-loading="loading">
      <person-info v-model="address"
                   :personInfo="personInfo"
                   v-if="currentStep === 1"
                   ref="personInfo"></person-info>
      <sdk-Info v-if="currentStep === 2"
                ref="sdkInfo"></sdk-Info>
      <meterials v-if="currentStep === 3"
                 ref="meterials"></meterials>
      <div class="success-submit"
           v-if="currentStep === 4">
        <h5 class="success-title"><i class="iconfont iconchenggong"></i>提交成功！</h5>
        <p class="success-des">您上传的SDK信息将由工作人员提交送检</p>
        <router-link class="theme-btn"
                     :to="{name:'mySdk'}">返回列表</router-link>
      </div>
      <footer v-if="currentStep !== 4"
              :class="{'last-step': currentStep === 3}">
        <gt-button @click="lastStep"
                   v-if="currentStep !== 1">上一步</gt-button>
        <button @click="nextStep"
                v-if="currentStep !== 3"
                type="button"
                class="theme-btn">下一步</button>
        <button @click="validate"
                v-if="currentStep === 3"
                type="button"
                class="theme-btn">{{btnTxt}}</button>
      </footer>
    </div>
    <!-- <comfirm-info ref="comfirmInfo"
                  @comfirm="comfirm"
                  :address="address"></comfirm-info> -->
  </div>
</template>

<script>
import PersonInfo from './person/index'
import SdkInfo from './sdk_info/index'
import Meterials from './materials/index'
// import ComfirmInfo from './confirm_info'
import { getPersonalInfo } from '@/api/account/index'
import { submit, reSubmit, getSubmitInfo } from '@/api/sdk/index'
import {
  Loading,
  Message
} from 'get-ui-vue'
import store from '@/store/index'
let SOURCEDATA = {
  // personal: {
  //   name: '',
  //   phone: '',
  //   postcode: '',
  //   province: '',
  //   city: '',
  //   area: '',
  //   street: ''
  // },
  sdk: {
    id: '',
    name: '',
    sdkName: '',
    version: '',
    platform: '',
    serviceTrades: []
  },
  materials: {
    instruction: {
      id: '',
      name: ''
    },
    checkout: {
      id: '',
      name: ''
    },
    statement: {
      id: '',
      name: ''
    },
    authorization: {
      id: '',
      name: ''
    },
    contract: {
      id: '',
      name: ''
    },
    cert: [],
    other: [],
    devMember: {
      id: '',
      name: ''
    }
  },
  recipientsId: ''
}
let sourceData = null
let personInfo = null
export default {
  name: 'SdkDetection',
  components: {
    PersonInfo,
    SdkInfo,
    Meterials
    // ComfirmInfo
  },
  provide: function () {
    return {
      sourceData: this.sourceData
    }
  },
  data () {
    let btnTxt = '确认提交'
    if (this.$route.query.type === 'update') {
      if (Number(this.$route.query.status) === 3) {
        btnTxt = '再次提交'
      } else {
        btnTxt = '重新提交'
      }
    }
    return {
      btnTxt,
      loading: false,
      address: '',
      currentStep: 1,
      personInfo,
      sourceData,
      stepOpt: [{
        icon: 'iconfont iconrenzhengchenggong',
        title: '个人信息确认',
        text: '请先确认个人信息'
      }, {
        icon: 'iconfont icontianxie',
        title: '填写SDK信息',
        text: '填写上传相关信息'
      }, {
        icon: 'iconfont iconshangchuan',
        title: '上传SDK送检材料',
        text: '企业安全管理能力情况评估'
      }]
    }
  },
  methods: {
    submit () {
      let params = JSON.parse(JSON.stringify(this.sourceData))
      this.loading = true
      let reqMethod
      // this.$route.query.type === 'update' ? reqMethod = reSubmit : reqMethod = submit
      if (this.$route.query.type === 'update') {
        params.resId = Number(this.$route.query.id)
        params.status = this.$route.query.status
        reqMethod = reSubmit
      } else {
        reqMethod = submit
      }
      reqMethod(params).then(res => {
        this.loading = false
        this.currentStep = 4
      }, errRes => {
        this.loading = false
      })
    },
    validate () {
      this.$refs.meterials.validate().then(res => {
        if (!res.includes(false)) {
          this.submit()
        }
      })
    },
    comfirm () {
      this.currentStep = 2 // 明确指向
    },
    lastStep () {
      this.currentStep--
    },
    nextStep () {
      if (this.currentStep === 1) {
        this.$refs.personInfo.validate().then(res => {
          if (res) {
            this.$refs.personInfo.generateParams()
            this.currentStep = 2 // 明确指向
          }
        })
      } else if (this.currentStep === 2) {
        this.$refs.sdkInfo.validate().then(res => {
          if (!res.includes(false)) {
            this.$refs.sdkInfo.generateParams()
            this.currentStep++
          }
        })
      }
      // this.currentStep++
    }
  },
  created () {

  },
  beforeRouteEnter (to, from, next) {
    if (store.getters.getAccount.auditStatus !== 1) { // 未进行实名认证
      Message.warning('请先进行实名认证')
      next({ name: 'accountCertification' })
      return false
    }
    if (store.getters.getAccount.auditType === 1) { // 个人认证不能使用
      Message.warning('本功能暂时未对个人认证用户开放')
      next({ name: 'accountCertification' })
      return false
    }
    let loadingInstance = Loading.service({
      fullscreen: true
    })

    store.dispatch('GET_GEO').then(res => {
      if (to.query.type === 'update') {
        getPersonalInfo({}).then(res => {
          let record = res.data.data
          personInfo = JSON.parse(JSON.stringify(record))
          let status = Number(to.query.status)
          getSubmitInfo({ id: to.query.id, status }).then(res => {
            const resData = res.data.data
            if (status !== 3) { // 审核没通过,审核没通过的时候后端只返回部分字段，所以需要前端补齐
              resData.record.sdk = JSON.parse(JSON.stringify(SOURCEDATA.sdk))
              resData.record.materials = JSON.parse(JSON.stringify(SOURCEDATA.materials))
              // sourceData = Object.assign(resData.record, JSON.parse(JSON.stringify(SOURCEDATA)))
            }
            sourceData = { ...resData.record }
            next()
            loadingInstance.close()
          }, errRes => {
            loadingInstance.close()
            next({ name: 'mySdk' })
          })
        }, errRes => {
          loadingInstance.close()
          next({ name: 'mySdk' })
        })
      } else {
        getPersonalInfo({}).then(res => {
          let record = res.data.data
          personInfo = JSON.parse(JSON.stringify(record))
          sourceData = JSON.parse(JSON.stringify(SOURCEDATA)) // 重新赋值
          // sourceData.personal = { ...record.personal }
          next()
          loadingInstance.close()
        }, errRes => {
          loadingInstance.close()
          next({ name: 'mySdk' })
        })
      }
    }, errRes => {
      next({ name: 'mySdk' })
      loadingInstance.close()
    })
  }
}
</script>

<style lang='less' scoped>
.sdk-detection-view {
  width: 856px;
  margin: 0 auto;
  padding-top: 40px;
  /deep/article {
    width: 650px;
    margin: 0 auto;
    .cpl {
      margin-bottom: 20px;
      .cpl-header {
        display: flex;
        height: auto;
        margin-bottom: 16px;
        align-items: center;
        .header-tip {
          display: inline-flex;
          align-items: center;
          margin-left: 20px;
          color: #a94442;
          font-size: 12px;
          .iconfont {
            margin-right: 10px;
          }
        }
      }
      .cpl-body {
        text-align: left;
        border: 1px solid #dddddd;
        .gt-form-item__label {
          font-size: 14px;
        }
        .is-error {
          /deep/.gt-textarea__inner,
          /deep/.gt-input__inner,
          /deep/.gt-upload2--picture-card {
            border-color: @form-danger;
          }
        }
      }
      .cpl-footer {
        text-align: left;
      }
    }
  }
}
.step-wrap {
  margin-bottom: 60px;
}
footer {
  width: 650px;
  margin: 0 auto;
  text-align: center;
  .gt-button {
    margin-right: 20px;
  }
}
.last-step {
  text-align: left;
}
.success-submit {
  text-align: center;
  .success-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    .iconfont {
      margin-right: 10px;
      font-size: 25px;
      color: #2d9939;
      font-weight: normal;
    }
  }
  .success-des {
    margin-bottom: 20px;
    font-size: 14px;
    color: #333333;
  }
}
</style>
